<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<plant-select />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
import PlantSelect from './PlantSelect.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PlantSelect },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);

			//this.resetState_();
			this.getGroups_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	created() {
		this.getPlants_()
			.then(() => {
				this.searchList();
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message ? error.message : error
				});
				Promise.reject(error);
			});
	}
};
</script>

<style></style>
